module.exports = __webpack_public_path__ + "media/images/new_home/product-4-a09f81b8cd43bb52ee0098437f00a26e.png";